import Link from 'next/link';
import PropTypes from 'prop-types';
import styles from './Blog.module.scss';
import Button from '../../atoms/Button';

export default function Blog(props) {
  const {
    title, posts, button, fullScreen,
  } = props;
  const renderFirstPost = () => {
    const firstPost = posts[0];

    return (
      <Link href={firstPost.url}>
        <div className={styles['blog__main-card']}>
          <img className={styles['blog__main-img']} src={firstPost.feature_image} alt="" />
          <div className={styles.blog__tag}>{firstPost.tag.name}</div>
          <div className={styles['blog__main-title']}>{firstPost.title}</div>
          <div className={styles['blog__main-excerpt']}>{firstPost.excerpt}</div>
        </div>
      </Link>
    );
  };

  const renderPostList = () => {
    const postList = posts.slice(1);

    return postList.map((post, index) => (
      <Link href={post.url} key={index}>
        <div className={styles['blog__side-card']}>
          <img className={styles['blog__side-img']} src={post.feature_image} alt="" />
          <div className={styles['blog__side-card-content']}>
            <div className={styles.blog__tag}>{post.tag.name}</div>
            <div className={styles['blog__side-card-title']}>{post.title}</div>
          </div>
        </div>
      </Link>
    ));
  };

  const containerClassName = [
    styles.blog,
    fullScreen ? styles['--full-screen'] : '',
  ].join(' ').trim();

  return (
    <section className={containerClassName}>
      <div className={styles.blog__title}>{title}</div>
      <div className={styles.blog__body}>
        {renderFirstPost()}
        <div className={styles['blog__side-container']}>
          <div className={styles['blog__featured-title']}>Featured Blog Posts</div>
          {renderPostList()}
        </div>
      </div>
      {button && (
      <div className={styles['blog__view-more-container']}>
        <Button {...button} outLine>
          {button.label}
        </Button>
      </div>
      )}

    </section>
  );
}

Blog.defaultProps = {
  title: null,
  posts: [],
  button: { label: 'View More', href: '#' },
  fullScreen: false,
};

Blog.propTypes = {
  /**
   * Title of block
   */
  title: PropTypes.string,
  /**
   * Posts to render in block
   */
  // eslint-disable-next-line react/forbid-prop-types
  posts: PropTypes.array,
  /**
   * Button object that contains href and label
   */
  // eslint-disable-next-line react/forbid-prop-types
  button: PropTypes.object,
  /**
   * Is the block fullscreen or is it rendered in another container?
   */
  fullScreen: PropTypes.bool,
};
